import React from 'react';

/** Texto só para leitor de tela; o visual fica por conta do shimmer. */
function Loading({ label = 'Carregando…' }: { label?: string }) {
  return <span className="ex-sr">{label}</span>;
}

export function ChipsSkeleton() {
  return (
    <div className="explore-chips" aria-hidden>
      <span className="sk sk-chip" style={{ width: 64 }} />
      <span className="sk sk-chip" style={{ width: 132 }} />
      <span className="sk sk-chip" style={{ width: 96 }} />
    </div>
  );
}

export function GallerySkeleton({ withFeature = true, count = 8 }: { withFeature?: boolean; count?: number }) {
  return (
    <div role="status" aria-busy="true">
      <Loading label="Carregando modelos…" />
      {withFeature && (
        <div className="explore-feature is-skeleton" aria-hidden>
          <div className="sk explore-feature-media" />
          <div className="explore-feature-info">
            <span className="sk sk-line" style={{ width: '70%', height: 28 }} />
            <span className="sk sk-line" style={{ width: '95%' }} />
            <span className="sk sk-line" style={{ width: '80%' }} />
            <span className="sk sk-line" style={{ width: 168, height: 44, marginTop: 8 }} />
          </div>
        </div>
      )}
      <div className="explore-grid" aria-hidden>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="explore-card-sk">
            <div className="sk explore-media-sk" />
            <span className="sk sk-line" style={{ width: '72%' }} />
            <span className="sk sk-line" style={{ width: '38%', height: 10 }} />
          </div>
        ))}
      </div>
    </div>
  );
}

export function ViewerPanelSkeleton() {
  return (
    <div role="status" aria-busy="true" className="ex-stack">
      <Loading label="Carregando campos…" />
      <span className="sk sk-line" style={{ width: '40%', height: 12 }} aria-hidden />
      <span className="sk sk-line" style={{ width: '100%', height: 44 }} aria-hidden />
      <span className="sk sk-line" style={{ width: '30%', height: 12 }} aria-hidden />
      <span className="sk sk-line" style={{ width: '100%', height: 44 }} aria-hidden />
    </div>
  );
}

export function StudioListSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div role="status" aria-busy="true">
      <Loading label="Carregando modelos do estúdio…" />
      <div className="studio-grid" aria-hidden>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="studio-tile is-skeleton">
            <div className="sk studio-tile-media" />
            <div className="studio-tile-body">
              <span className="sk sk-line" style={{ width: '68%' }} />
              <span className="sk sk-line" style={{ width: '45%', height: 10 }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function EditorSkeleton() {
  return (
    <div className="explore-page studio-editor" role="status" aria-busy="true">
      <Loading label="Carregando o modelo…" />
      <div aria-hidden>
        <span className="sk sk-line" style={{ width: 90, height: 12 }} />
        <span className="sk sk-line" style={{ width: 320, height: 32, marginTop: 12 }} />
        <div className="studio-layout" style={{ marginTop: 24 }}>
          <div className="studio-panel ex-stack">
            <span className="sk sk-line" style={{ width: '30%', height: 12 }} />
            <span className="sk sk-line" style={{ width: '100%', height: 44 }} />
            <span className="sk sk-line" style={{ width: '30%', height: 12 }} />
            <span className="sk sk-line" style={{ width: '100%', height: 44 }} />
            <span className="sk sk-line" style={{ width: '20%', height: 12 }} />
            <span className="sk sk-line" style={{ width: '100%', height: 180 }} />
          </div>
          <div className="studio-aside">
            <div className="studio-panel ex-stack">
              <span className="sk" style={{ width: '100%', aspectRatio: '16 / 9', display: 'block', borderRadius: 12 }} />
              <span className="sk sk-line" style={{ width: '100%', height: 44 }} />
              <span className="sk sk-line" style={{ width: '100%', height: 44 }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
